import centros from '../assets/centros.json';
import sociedades from '../assets/sociedades.json';

export const requiresAdditionalSignature = (fechaNacimiento)=> {
  const date = new Date(fechaNacimiento);
  const now = new Date();
  now.setFullYear(now.getFullYear() - 18);
  return date > now;
}

export const getFecha = ()=> {
  const date = new Date();
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return date.toLocaleDateString('es-ES', options);
}

export const getDatosCentro = (centro)=> {
  if (!centro) return null
  const academia = centros.find(c=> c.nombre.toLowerCase() === centro.toLowerCase())
  const sociedad = sociedades.find(s=> s.nombre === academia.sociedad)
  return { ...academia, sociedad }
}